module.exports = __webpack_public_path__ + "static/media/refer_a_friend_preview.8e374ec1.png";